<template>
    <div style="width: 1300px;margin: 0px auto;">
        <div>
           <div>
                <input value="" v-model="search" style="width:200px" class="el-input__inner" type="text">
                <button @click="sa_article_sour()" type="button" class="el-button el-button--primary" style="width: 120px;margin-bottom: 3px;"><!----><!----><span>sour database</span></button>
                <span style="font-size: 18px;">
                    <b>{{tit_name}}</b>
                </span>
           </div>
          
        </div>
        
        <div class="el-row">
          <div class="el-col el-col-5">
            <div>
                <ul>
                    <li class="wtq-sty" style="height: auto;border:0px" v-for="item in left_mean">
                        <div  @click="listPage()" style="border-bottom: 1px solid black;height: 27px;">
                            <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_article', query: {id: item.id}}">{{item.name}}</router-link>
                        </div>
                            <ul>
                                <li style="margin-left: 20px;padding:10px 0 10px 0;" class="wtq-sty" v-for="ite in item.ch" @click="listPage()">
                                    <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_type', query: {type_id: ite.id,id: item.id}}">{{ite.type_name}}</router-link>
                                </li>
                            </ul>
                    </li>
                </ul>
            </div>
          </div>
          <div class="el-col el-col-1" style="height:77px">
          
          </div>
          <div class="el-col el-col-18 news" style="min-height: 777px;margin-bottom: 7px;border: 1px solid #60605896;" >
             <el-table :data="tableData" style="width: 100%">
                <el-table-column  prop="title" >
                    <template slot="header">
                        <span style="font-size: 16px;color: #fff">title</span>
                    </template>
                    <template slot-scope="scope">
                        <span class="wtq_hover" style="cursor: pointer;" :onclick="'window.location=\'sa_show?id='+scope.row.pass_id+'\''" v-html="scope.row.title"></span>
                    </template>
                </el-table-column>

                <el-table-column  prop="date" width="360">
                    <template slot="header">
                        <span style="font-size: 16px;color: #fff;"> Update time </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="news-pages"  style="margin-top: 40px;">
                <el-pagination
                 @current-change="change_page"
                 @size-change="change_size"
                  :page-size="show"
                  background
                  :current-page="page"
                  :page-count="page"
                  layout="prev, pager, next,sizes,jumper"
                  :total="total"
                  hide-on-single-page>
                </el-pagination>
            </div>
          </div>
        </div>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                left_mean:'',
                tit_name:'',
                tableData:[],
                
                
                page: 1, // 当前页码
                total: '', // 总条数
                allPage: '', // 总页数
                show: '10', // 当前每页显示条数
            }
        },

        mounted: function () {
            this.search=this.get_get_val('name');
            this.listPage();
        },

        methods: {
            change_page(val){
                this.page=val;
                this.listPage();
            },
            change_size(val){
                this.show=val;
                this.listPage();
            },
            listPage() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let type_id=this.get_get_val('type_id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_type?en=1&id=' + type_id+'&page='+this.page+'&show='+this.show,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    _this.tableData=response.data.tableData;
                    _this.tit_name=response.data.tit_name;
                    
                    this.page  = response.data.page_msg.page
                    this.allPage  = response.data.page_msg.all_page
                    this.total  = response.data.page_msg.show * response.data.page_msg.all_page
                    this.show  = response.data.page_msg.show
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            sa_article_sour() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                
                location.href = '/history/sa_sour?name='+ this.search
                
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_article?en=1&id=' + id+'&name='+ this.search,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    _this.right_div=response.data.right_div;
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            // 下载
            downloadMarkOne: function (row) {
                location.href = '/api/pre/json_go/file_xz?en=1&tool_id='+row.tool_id+'&type=1'
            },
            downloadMarkTwo: function (row) {
                location.href = '/api/pre/json_go/file_xz?en=1&tool_id='+row.tool_id+'&type=2'
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        }
    }
</script>

<style>
    .wtq-sty{
        height: 20px;
        border-bottom: 1px solid #60605896;
        padding: 10px 0 10px 20px;
    }
    .news th { background-color:  #409eff !important; }
    .news .news-title { line-height: 200px;height: 120px }
    .news .title-span { font-size: 36px;color: rgba(51,51,51,1); }
    .news .news-table { padding: 20px;/*height: 720px*/ }
    .news .article-item { margin-top: 40px;font-size: 14px }
    .news  .title-select { margin-left: 15%;line-height: 0px;width: 240px }
    .news .title-Data { margin-top: 40px; }
    .news .table-content { margin-top: 25px;font-size: 14px;cursor: pointer }
    
    .wtq_hover:hover{color: #6190cd;}
</style>


// WEBPACK FOOTER //
// src/pages/product/sa_type.vue